export default [
  {
    path: '/main/groups',
    meta: {
      tag: 'list_groups',
      name: 'Grupos',
      breadcrumb: 'Grupos'
    },
    component: () => import(/* webpackChunkName: "group-list" */ '@/views/main/settings/users/groups/Index.vue'),
    children: [
      {
        path: '',
        name: 'listgroups',
        meta: {
          tag: 'list_groups',
          menu: 'settings',
          name: 'Grupos',
        },
        component: () => import(/* webpackChunkName: "group-list" */ '@/views/main/settings/users/groups/List.vue')
      },
      {
        path: '/main/groups/add',
        name: 'addgroup',
        meta: {
          tag: 'add_groups',
          menu: 'settings',
          name: 'Adicionar | Grupo',
          breadcrumb: 'Adicionar Grupo'
        },
        component: () => import(/* webpackChunkName: "group-add" */ '@/views/main/settings/users/groups/Add.vue')
      },
      {
        path: '/main/groups/:id',
        name: 'editgroup',
        meta: {
          tag: 'edit_groups',
          menu: 'settings',
          name: 'Editar | Grupo',
          breadcrumb: 'Editar Grupo'
        },
        component: () => import(/* webpackChunkName: "group-edit" */ '@/views/main/settings/users/groups/Edit.vue')
      }
    ]
  }
]